import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=22009b0b&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=22009b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22009b0b",
  null
  
)

export default component.exports